import http from './httpClient';

class MenuService {
  // Get all menu items (with optional language parameter for translations)
  static async getMenuItems(language = 'en', includeInactive = false) {
    try {
  const data = await http.get(`/menu/items?language=${language}${includeInactive ? '&includeInactive=true' : ''}`);
  // In development mode, return empty array if auth fails
  if (!data.success) {
    const isDevelopment = process.env.NODE_ENV === 'development' || 
                         window.location.hostname === 'localhost' || 
                         window.location.hostname.match(/^(172|192|10)\./);
    if (isDevelopment && data.error && (data.error.includes('token') || data.error.includes('Access'))) {
      console.warn('⚠️ Development mode: Returning empty menu items array');
      return { success: true, data: [] };
    }
    throw new Error(data.error || 'Failed to fetch menu items');
  }
  return data;
    } catch (error) {
      console.error('Error fetching menu items:', error);
      // In development mode with auth errors, return empty array instead of throwing
      const isDevelopment = process.env.NODE_ENV === 'development' || 
                           window.location.hostname === 'localhost' || 
                           window.location.hostname.match(/^(172|192|10)\./);
      if (isDevelopment && error.message && (error.message.includes('token') || error.message.includes('Access'))) {
        console.warn('⚠️ Development mode: Returning empty menu items array after error');
        return { success: true, data: [] };
      }
      throw error;
    }
  }

  // Get menu categories
  static async getMenuCategories() {
    try {
  const data = await http.get('/menu/categories');
  // In development mode, return empty array if auth fails
  if (!data.success) {
    const isDevelopment = process.env.NODE_ENV === 'development' || 
                         window.location.hostname === 'localhost' || 
                         window.location.hostname.match(/^(172|192|10)\./);
    if (isDevelopment && data.error && (data.error.includes('token') || data.error.includes('Access'))) {
      console.warn('⚠️ Development mode: Returning empty menu categories array');
      return { success: true, data: [] };
    }
    throw new Error(data.error || 'Failed to fetch menu categories');
  }
  return data;
    } catch (error) {
      console.error('Error fetching menu categories:', error);
      // In development mode with auth errors, return empty array instead of throwing
      const isDevelopment = process.env.NODE_ENV === 'development' || 
                           window.location.hostname === 'localhost' || 
                           window.location.hostname.match(/^(172|192|10)\./);
      if (isDevelopment && error.message && (error.message.includes('token') || error.message.includes('Access'))) {
        console.warn('⚠️ Development mode: Returning empty menu categories array after error');
        return { success: true, data: [] };
      }
      throw error;
    }
  }

  // Test image accessibility
  static async testImage(filename) {
    try {
  const data = await http.get(`/menu/test-image/${filename}`);
  if (!data.success) throw new Error(data.error || 'Failed to test image');
  return data;
    } catch (error) {
      console.error('Error testing image:', error);
      throw error;
    }
  }
}

export default MenuService;